'use client';

import { cn } from '@/lib/utils';

function scoreColor(score: number): string {
  if (score >= 75) return 'text-emerald-500';
  if (score >= 50) return 'text-amber-500';
  return 'text-destructive';
}

export function ScoreRing({
  score,
  size = 'md',
  className,
}: {
  score: number;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const sizeClasses = {
    xs: 'h-7 w-7',
    sm: 'h-10 w-10',
    md: 'h-16 w-16',
    lg: 'h-20 w-20',
  };
  const textClasses = {
    xs: 'text-2xs font-bold',
    sm: 'text-label font-bold',
    md: 'text-title-md',
    lg: 'text-title-lg',
  };
  const color = scoreColor(score);

  return (
    <div className={cn('relative flex shrink-0 items-center justify-center', sizeClasses[size], className)}>
      <svg viewBox="0 0 36 36" className={cn('h-full w-full -rotate-90', sizeClasses[size])}>
        <circle
          cx="18"
          cy="18"
          r="15.915"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          className="text-border"
        />
        <circle
          cx="18"
          cy="18"
          r="15.915"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeDasharray={`${score} ${100 - score}`}
          strokeLinecap="round"
          className={color}
        />
      </svg>
      <span className={cn('absolute tabular-nums', textClasses[size], color)}>
        {score}
      </span>
    </div>
  );
}
